import { useCallback, useEffect, useRef, useState } from 'react';
import { Divider, Drawer } from '@material-ui/core';
import PageContainer from 'layout/components/PageContainer';
import PageHeader from 'layout/components/PageHeader';
import { Button } from '@vadiun/react-components';
import { useVerifyAction } from '@vadiun/react-hooks-legacy';
import { useSuperMutation } from '@vadiun/react-hooks';
import ViajeTrasladoBaseFilters from '../../viajeTraslado/components/ViajeTrasladoBaseFilters';
import ViajeTrasladoResumenModal from '../../viajeTraslado/components/ViajeTrasladoResumenModal';
import { ViajeTrasladoDeleteTable } from '../components/ViajeTrasladoDeleteTable';
import { BusType } from '../../viajeTraslado/models/TransferReservation';
import { createTableScrollHandler } from 'utils/tableUtils';
import ChipsBar from 'shared/components/filters/ChipsBar';
import TrashAllFilters from 'shared/components/filters/TrashAllFilters';
import CloseFiltersButton from 'shared/components/Table/CloseFiltersButton';
import RefreshList from 'shared/components/Table/Refresh';
import ColumnSelector from 'shared/components/Table/actions-buttons/ColumnSelector';
import FiltersButton from 'shared/components/Table/FiltersButton';
import TableToolbar from 'shared/components/Table/TableToolbar';
import useViajesTraslado from '../../viajeTraslado/services/ViajeTrasladoService';
import { TransferReservationManagmentModel } from '../models/TransferReservationManagment';
import {
  columnsLabels,
  getDefaultFilters,
  useGestionDeleteReserves
} from '../hooks/useGestionDeleteReserves';

const ViajeTrasladoDeletePage = () => {
  const tableRef = useRef<HTMLDivElement>(null);
  const ViajeTrasladoService = useViajesTraslado();
  const verifyAction = useVerifyAction();

  const [showFilters, setShowFilters] = useState(false);

  const {
    gestionDeleteReserves,
    filters,
    columnVisibility,
    setColumnVisibility,
    onFiltersChange,
    onChangePage,
    onChangeRowsPerPage,
    onSortChange,
    reload
  } = useGestionDeleteReserves();

  const [locationsDetail, setLocationsDetail] = useState<
    | {
        isOpen: false;
        details: undefined;
      }
    | {
        isOpen: true;
        details: TransferReservationManagmentModel;
      }
  >({ isOpen: false, details: undefined });

  const deleteReservationMutation = useSuperMutation(
    ViajeTrasladoService.deleteReservation,
    {
      onSuccess() {
        reload();
      }
    }
  );

  const [optionsBuses, setOptionsBuses] = useState<BusType[]>([]);

  const getOptionsBuses = useCallback(async () => {
    const buses = await ViajeTrasladoService.getOptionsBuses();
    setOptionsBuses(buses);
  }, [ViajeTrasladoService]);

  useEffect(() => {
    getOptionsBuses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={tableRef}>
      <PageHeader area="Operaciones" title="Eliminar reserva" />
      <div
        className="sticky top-0 right-0 left-0 flex flex-col "
        style={{
          zIndex: 101,
          background: '#EAEDF5',
          // border: '1px solid rgba( 255, 255, 255, 0.18 )',
          marginBottom: '-24px'
        }}
      >
        <div className="flex w-full px-8 mt-2">
          <TableToolbar
            chips={
              <ChipsBar
                filters={filters}
                defaultFilters={getDefaultFilters()}
                onFiltersChange={onFiltersChange}
              />
            }
            actions={
              <>
                <RefreshList
                  onRefreshTable={() => reload()}
                  isRefreshing={gestionDeleteReserves.isLoading}
                />
                <ColumnSelector
                  columns={columnVisibility}
                  onChange={setColumnVisibility}
                  columnLabels={columnsLabels}
                />
                <FiltersButton
                  onClick={() => setShowFilters(true)}
                  isActive={showFilters}
                />
              </>
            }
          />
        </div>
      </div>
      <Drawer
        variant="persistent"
        anchor="right"
        open={showFilters}
        className="max-w-md"
        transitionDuration={300}
      >
        <div className="flex h-full flex-col">
          <div
            className="flex items-center justify-between px-2"
            style={{ backgroundColor: '#00163B' }}
          >
            <CloseFiltersButton
              onCloseFilters={() => setShowFilters(false)}
              inOpen={showFilters}
            />
            <TrashAllFilters
              onClick={() => onFiltersChange(getDefaultFilters())}
            />
          </div>
          <Divider />
          <ViajeTrasladoBaseFilters
            onSubmit={async (filters) => {
              onFiltersChange(filters);
              setShowFilters(false);
            }}
            initialValues={filters}
            filterByPreAssignedDriver={false}
            optionsBuses={optionsBuses}
          />
        </div>
      </Drawer>
      <PageContainer lessMargin>
        <div className="w-full">
          <ViajeTrasladoDeleteTable
            handlePageChange={createTableScrollHandler(tableRef)}
            tableQuery={gestionDeleteReserves}
            columnVisibility={columnVisibility}
            onChangePage={onChangePage}
            onChangeRowsPerPage={onChangeRowsPerPage}
            onSortChange={onSortChange}
            onLocationsDetails={(reservation) =>
              setLocationsDetail({ isOpen: true, details: reservation })
            }
            onDelete={(id) => (
              <Button
                onClick={() =>
                  verifyAction({
                    title: 'Estas por eliminar una reserva!',
                    body: 'Esta accion va a eliminar una reserva. ¿Estas seguro?',
                    onAccept: () => deleteReservationMutation.mutate(id)
                  })
                }
                variant="light"
                color="red"
                disabled={deleteReservationMutation.isLoading}
              >
                Eliminar
              </Button>
            )}
          />
        </div>
      </PageContainer>
      {locationsDetail.details && (
        <ViajeTrasladoResumenModal
          isOpen={locationsDetail.isOpen}
          reservation={locationsDetail.details!}
          handleClose={() =>
            setLocationsDetail({ isOpen: false, details: undefined })
          }
        />
      )}
    </div>
  );
};

export default ViajeTrasladoDeletePage;
